import { HttpMethod, httpClient } from './http-client';

export const getPendingInteractionsByServiceId = (serviceId: number) => {
  return httpClient(`/pendingInteractions/${serviceId}`, HttpMethod.Get, null);
};